import { ExportTypeBaseService } from '/@/modules/export/services/ExportTypeBaseService';
import Lang from '/@/modules/core/app/services/Lang';

export class FinalTaxesSummaryExportService extends ExportTypeBaseService {
  getFilename(): string {
    return 'final-taxes-summary.pdf';
  }

  getSnackBarTitle(): string {
    return Lang.t('tax.final-taxes-summary-exporting');
  }
}

export default new FinalTaxesSummaryExportService();
